<div class="fuse-vertical-navigation-wrapper">
    <div class="fuse-vertical-navigation-header">
        <ng-content select="[fuseVerticalNavigationHeader]"></ng-content>
    </div>

    <div class="flex flex-col h-full">
        <div class="fuse-vertical-navigation-content" fuseScrollbar [fuseScrollbarOptions]="{
                wheelPropagation: inner,
                suppressScrollX: true,
            }" #navigationContent>
            <div class="fuse-vertical-navigation-content-header">
                <ng-content select="[fuseVerticalNavigationContentHeader]"></ng-content>
            </div>
            <div class="transition-all duration-300" [class.opacity-50]="!userHasLocation"
                [class.pointer-events-none]="!userHasLocation" [class.grayscale]="!userHasLocation">
                @for (item of navigation; track trackByFn($index, item)) {
                @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
                @if (item.type === 'aside') {
                <fuse-vertical-navigation-aside-item [item]="item" [name]="name" [activeItemId]="activeAsideItemId"
                    [autoCollapse]="autoCollapse" [skipChildren]="true"
                    (click)="toggleAside(item)"></fuse-vertical-navigation-aside-item>
                }
                @if (item.type === 'basic') {
                <fuse-vertical-navigation-basic-item [item]="item" [name]="name"></fuse-vertical-navigation-basic-item>
                }
                @if (item.type === 'collapsable') {
                <fuse-vertical-navigation-collapsable-item [item]="item" [name]="name"
                    [autoCollapse]="autoCollapse"></fuse-vertical-navigation-collapsable-item>
                }
                @if (item.type === 'divider') {
                <fuse-vertical-navigation-divider-item [item]="item"
                    [name]="name"></fuse-vertical-navigation-divider-item>
                }
                @if (item.type === 'group') {
                <fuse-vertical-navigation-group-item [item]="item" [name]="name"
                    [autoCollapse]="autoCollapse"></fuse-vertical-navigation-group-item>
                }
                @if (item.type === 'spacer') {
                <fuse-vertical-navigation-spacer-item [item]="item"
                    [name]="name"></fuse-vertical-navigation-spacer-item>
                }
                }
                }
            </div>
            <div class="fuse-vertical-navigation-content-footer">
                <ng-content select="[fuseVerticalNavigationContentFooter]"></ng-content>
            </div>

        </div>

        <div class="border opacity-25 border-gray-50"></div>
        @if (showLocationSelector) {
        <div class="p-4 mb-4 mx-2">

            @if (!userHasLocation && !isAddingNew) {
            <div class="flex items-center justify-center p-3 rounded-xl bg-yellow-500/10 text-yellow-600 border border-yellow-500/20 cursor-pointer hover:bg-yellow-500/20 transition-colors"
                (click)="triggerNewLocationSetup()">
                <mat-icon class="text-yellow-500 icon-size-5 mr-2"
                    svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
                <span class="font-medium text-sm">Agregar mi consultorio</span>
            </div>

            } @else if (isAddingNew) {
            <div class="flex items-center justify-center p-3 rounded-xl bg-red-500/10 text-red-600 border border-red-500/20 cursor-pointer hover:bg-red-500/20 transition-colors"
                (click)="cancelNewLocationSetup()">
                <mat-icon class="text-red-500 icon-size-5 mr-2" svgIcon="heroicons_outline:"></mat-icon>
                <span class="font-medium text-sm">Cancelar registro</span>
            </div>

            } @else {
            <div class="flex items-center justify-between p-3 rounded-xl bg-indigo-200/10 text-indigo-300 cursor-pointer hover:bg-indigo-500/20 transition-colors"
                [matMenuTriggerFor]="locationMenu">

                <div class="flex items-center gap-3 overflow-hidden">
                    <div class="flex items-center justify-center min-w-8 h-8 rounded-lg bg-indigo-900/20">
                        <mat-icon class="text-white icon-size-5"
                            [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
                    </div>
                    <div class="flex flex-col min-w-0">
                        <span class="text-[10px] font-bold text-gray-50 tracking-wider leading-none mb-1">Atendiendo
                            en</span>
                        <span class="text-sm font-semibold text-white truncate max-w-[130px]"
                            [title]="activeLocationName">
                            {{ activeLocationName }}
                        </span>
                    </div>
                </div>

                <mat-icon class="text-indigo-400 icon-size-4 flex-shrink-0 ml-1"
                    svgIcon="heroicons_outline:chevron-down"></mat-icon>
            </div>

            <mat-divider class="my-2"></mat-divider>
            <mat-menu #locationMenu="matMenu" class="min-w-64   ">
                <!-- <div class="px-4 py-3 border-b border-gray-100">
                    <p class="text-xs font-medium text-secondary">Cambiar de consultorio</p>
                </div> -->

                @for (lugar of installationCodesList; track lugar.codigoInstalacion) {
                <button mat-menu-item (click)="switchLocation(lugar)" class="text-sm"
                    [class.bg-accent-100]="lugar.codigoInstalacion === actualUserCode">
                    <mat-icon class="mr-2 icon-size-4"
                        [class.text-primary-600]="lugar.codigoInstalacion === actualUserCode"
                        [svgIcon]="lugar.codigoInstalacion === actualUserCode ? 'heroicons_outline:check-circle' : 'heroicons_outline:building-office'">
                    </mat-icon>
                    <span class="text-xs antialiased text-slate-600"
                        [class.text-primary-600]="lugar.codigoInstalacion === actualUserCode"
                        [class.text-semibold]="lugar.codigoInstalacion === actualUserCode">
                        {{ lugar.domicilio }}
                    </span>
                </button>
                }

                <mat-divider></mat-divider>

                <!-- <button mat-menu-item (click)="triggerNewLocationSetup()">
                    <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    <span>Agregar un nuevo domicilio</span>
                </button> -->
            </mat-menu>
            }
        </div>
        }
    </div>

    <div class="fuse-vertical-navigation-footer">
        <ng-content select="[fuseVerticalNavigationFooter]"></ng-content>
    </div>
</div>

@if (activeAsideItemId) {
<div class="fuse-vertical-navigation-aside-wrapper" fuseScrollbar [fuseScrollbarOptions]="{
            wheelPropagation: false,
            suppressScrollX: true,
        }" [@fadeInLeft]="position === 'left'" [@fadeInRight]="position === 'right'"
    [@fadeOutLeft]="position === 'left'" [@fadeOutRight]="position === 'right'">
    @for (item of navigation; track trackByFn($index, item)) {
    @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
    @if (item.type === 'aside' && item.id === activeAsideItemId) {
    <fuse-vertical-navigation-aside-item [item]="item" [name]="name"
        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-aside-item>
    }
    }
    }
</div>
}